import React, { useRef } from 'react'

import PlaceHolderPage from '../PlaceHolderPage'
import PlayerPage from '../PlayerPage'
import { PageWrapperElement } from './Styled'

interface PageWrapperProps {
  pageActivated: boolean
  videoInfo: any
  type: string
  imageCache: any
  updateImageCache: (id: any, src: string | null) => void
  handleAddLikeList: (videoInfo: any) => void
  handleAddCollectList: (videoInfo: any) => void
  preloadedImages: any[]
  autoplay: boolean
}

const PageWrapper = ({
  pageActivated,
  videoInfo,
  type,
  imageCache,
  updateImageCache,
  handleAddLikeList,
  handleAddCollectList,
  preloadedImages,
  autoplay,
}: PageWrapperProps) => {
  const pageRef = useRef<HTMLDivElement | null>(null)

  return (
    <PageWrapperElement ref={pageRef}>
      {pageActivated ? (
        type === 'short' ? (
          <PlayerPage
            autoplay={autoplay}
            mode="video"
            videoInfo={videoInfo}
            posterSrc={imageCache[videoInfo.id]?.preloaded ? imageCache[videoInfo.id].src : null}
            onBase64ImageLoad={(src: string | null) =>
              updateImageCache(videoInfo.id, src ? `data:image/jpeg;base64, ${src}` : null)
            }
            onLike={() => handleAddLikeList(videoInfo)}
            onSave={() => handleAddCollectList(videoInfo)}
            preloadedImages={preloadedImages}
          />
        ) : (
          <PlayerPage
            autoplay={autoplay}
            mode="promotion"
            promoteInfo={videoInfo}
            posterSrc={imageCache[videoInfo.id]?.preloaded ? imageCache[videoInfo.id].src : null}
            onBase64ImageLoad={(src: string | null) =>
              updateImageCache(videoInfo.id, src ? `data:image/jpeg;base64, ${src}` : null)
            }
            preloadedImages={preloadedImages}
          />
        )
      ) : (
        <PlaceHolderPage
          videoInfo={videoInfo}
          posterSrc={imageCache[videoInfo.id]?.preloaded ? imageCache[videoInfo.id].src : null}
          onBase64ImageLoad={(src: string | null) =>
            updateImageCache(videoInfo.id, src ? `data:image/jpeg;base64, ${src}` : null)
          }
        />
      )}
    </PageWrapperElement>
  )
}

export default PageWrapper
